// import React, 'react';
import { useEffect, useState, useRef } from 'react';
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import html2canvas from "html2canvas";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Swal from 'sweetalert2';
import { loadFontAsBase64 } from "../loadFont";

// You will need a library to generate QR codes. Install it using: npm install qrcode
import QRCode from 'qrcode';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { parse } from "node-html-parser"; 
import MachineResultImport from './MachineResultImport';

// मैंने आपके CSS को सीधे यहां स्टाइल ऑब्जेक्ट में डाल दिया है ताकि यह एक ही फाइल में रहे।
// आप इसे अपनी CSS फाइल में भी रख सकते हैं।
const styles = `
    .report-entry-container {
      background-color: #f0f2f5;
      border-radius: 8px;
    }
    .patient-details-card {
      background-color: #ffffff;
      border: 1px solid #dee2e6;
      border-radius: 5px;
      padding: 1rem;
    }
    .patient-details-card .table td {
      padding: 0.25rem 0.5rem;
      font-size: 0.9rem;
      border: none;
    }
    .patient-details-card .table strong {
      min-width: 90px;
      display: inline-block;
      color: #495057;
    }
    .report-table {
      background-color: #ffffff;
    }
    .report-table .table-header-blue {
      background-color: #405189;
      color: white;
    }
    .report-table th, .report-table td {
      vertical-align: middle;
      text-align: left;
      padding: 0.75rem;
    }
    .report-table .form-control {
      border: 1px solid #ced4da;
      border-radius: 4px;
      height: auto;
      padding: 0.375rem 0.75rem;
    }
    .nav-tabs .nav-link {
        color: #495057;
        border-bottom-width: 2px;
    }
    .nav-tabs .nav-link.active {
      color: #405189;
      border-color: #405189 #405189 #fff;
      font-weight: 600;
    }
      /* Accordion-style Investigation Section */
.investigation-section-accordion .accordion-item {
  border: 1px solid #dee2e6;
  border-radius: 5px;
  margin-bottom: 10px;
  background-color: #fff;
}

.investigation-section-accordion .accordion-header {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  gap: 15px;
}

.investigation-section-accordion .accordion-toggle-btn {
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1;
  padding: 0 10px;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  color: #28a745; /* Green color for '+' */
}

.investigation-section-accordion .accordion-toggle-btn.active {
    color: #dc3545; /* Red color for '-' */
}

.investigation-section-accordion .accordion-title {
  flex-grow: 1;
  font-weight: 500;
  color: #495057;
}

.investigation-section-accordion .accordion-body {
  padding: 15px;
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
}
.zindex-dropdown {
    z-index: 1050;
}



`;


const ReportEntry = () => {
  

  const stripAsterisks = (s) => {
    const str = String(s || '').trim();
    if (/^\*.+\*$/.test(str)) return str.replace(/^\*(.+)\*$/, '$1');
    return str;
  }; 
  
const [showPrintPopup, setShowPrintPopup] = useState(false);
const [printType, setPrintType] = useState("with"); // "with" or "without"
const [pendingPrintAction, setPendingPrintAction] = useState(null);
// add this near other state declarations
// add near other states
const [patientsLoading, setPatientsLoading] = useState(false);

// Add near other helpers
const resolveTestId = (test) => {
  return test?.lab_item_test_id ?? test?.lab_item_parent ?? test?.id ?? test?.lab_item_id ?? null;
};

// ===== Add near other state declarations =====
const [selectedTests, setSelectedTests] = useState(new Set()); // stores lab_item_test_id
const [selectAllTests, setSelectAllTests] = useState(false);

// Toggle a single test selection
const handleToggleTestSelect = (testOrId) => {
  const id = typeof testOrId === 'object' ? resolveTestId(testOrId) : testOrId;
  if (!id) return;

  setSelectedTests(prev => {
    const next = new Set(prev);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    return next;
  });
};


// Select / deselect all visible tests
const handleToggleSelectAll = () => {
  if (selectAllTests) {
    setSelectedTests(new Set());
    setSelectAllTests(false);
  } else {
    const allIds = new Set((formData.l11 || []).map(t => resolveTestId(t)).filter(Boolean));
    setSelectedTests(allIds);
    setSelectAllTests(true);
  }
};


// Build array of test objects from selectedTests
const getSelectedTestsArray = () => {
  if (!formData.l11) return [];
  return formData.l11.filter(t => selectedTests.has(t.lab_item_test_id ?? t.lab_item_parent ?? t.id));
};

// Print selected tests
const handlePrintSelectedTests = () => {
  const arr = getSelectedTestsArray();
  if (!arr.length) {
    toast.info("No tests selected to print.");
    return;
  }
  generatePdfForTests(arr);
};

const [todaysPatients, setTodaysPatients] = useState([]);

   const [Name, setName] = useState('');

       const [image, setImage] = useState('')
       const [watermarkImage, setWatermarkImage] = useState('');
       const [footerImage, setFooterImage] = useState('');
    const [isReportSaved, setIsReportSaved] = useState(false);
    const [searchKey, setSearchKey] = useState('');
    const [filteredPatients, setFilteredPatients] = useState([]);
    const [showSearchDropdown, setShowSearchDropdown] = useState(false);
    const inputRef = useRef();
    const dropdownRef = useRef();

    const [activeIndex, setActiveIndex] = useState(0);

      const htmlRef = useRef();
    const [formData, setFormData] = useState({
        test_id: "",
        test_id0: "",
        test_id1: "",
        test_id2: "",
        l1: [],
        l11: [],
        l2: [],
        l3: [],
        test_report_impression: '',
        test_report_datetime: "",
        test_report_notes: '',
        test_report_patient: '',
        test_report_user: '',
        page_no: 0,
        from: '',
        to: '',
        search_key: '',
        departs: [],
        selItem :{}
    });
    const [selectedUser, setSelectedUser] = useState(null);
    const [ldata, setLdata] = useState(null);


// collapsed-by-default toggle state for Additional Notes per test index
const [openNotes, setOpenNotes] = useState({});

const toggleNotes = (index) => {
  setOpenNotes(prev => ({ ...prev, [index]: !prev[index] }));
};

useEffect(() => {
    const now = new Date();

    const formattedDateTime = now.toLocaleString("en-GB", { 
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: false
  }).replace(/\//g, "-"); // ✅ slash ko dash me badalna

  const isoNow = new Date().toISOString();

setFormData(prev => ({
  ...prev,
  from: formatDateForInput(now),   // YYYY-MM-DD for input
  to: formatDateForInput(now),
  // store as ISO so formatDateTime12h can parse correctly in all browsers
  test_report_datetime: isoNow
}));




const storedData = sessionStorage.getItem("ldata");
  if (storedData) {
    const parsed = JSON.parse(storedData);
    setLdata(parsed);
    const today = new Date();
    getTests(parsed.user_id, today, today, true); // onlyToday=true -> stores today's list but no auto-select
  }
}, []);



useEffect(() => {
  // clear selection when tests list changes or patient changes
  setSelectedTests(new Set());
  setSelectAllTests(false);
}, [formData.test_id0,selectedUser]);

// helper to convert Date or date-string to YYYY-MM-DD
const toYMD = (d) => {
  if (!d) return '';
  const dt = (d instanceof Date) ? d : new Date(d);
  if (isNaN(dt.getTime())) return '';
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  const day = String(dt.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

const getTests = async (userId, fromDate, toDate, onlyToday = false) => {
  if (!userId) return;

  if (!onlyToday) {
    const fromY = parseToYMD(fromDate);
    const toY = parseToYMD(toDate);
    if (!fromY || !toY) {
      console.info("getTests: skipping fetch because date range missing. Use Search button to fetch historical data.");
      return;
    }
  }

  setPatientsLoading(true);

  const fd1 = new FormData();
  fd1.append('page_no', "none");
  fd1.append('search_key', "");
  // ADD THESE TWO LINES (important)
  const fromY = parseToYMD(fromDate) || formatDateForInput(new Date());
  const toY   = parseToYMD(toDate)   || formatDateForInput(new Date());
  fd1.append('from', fromY);
  fd1.append('to', toY);

  try {
    const response = await axios.post(AppConst.BASE_URL + AppConst.getLabRegListItmUrl, fd1, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 20000
    });
    

    if (response.data.status && Array.isArray(response.data.records)) {
      const normalized = response.data.records.map(rec => {
        let interp = (rec.interpretation && String(rec.interpretation).trim()) ? rec.interpretation : "";

        if (!interp && rec.test_interpretation) interp = rec.test_interpretation;
        if (!interp && rec.test_interpratation) interp = rec.test_interpratation;

        if (!interp && Array.isArray(rec.params) && rec.params.length > 0) {
          for (const p of rec.params) {
            if (p.test_interpretation && String(p.test_interpretation).trim()) { interp = p.test_interpretation; break; }
            if (p.test_interpratation && String(p.test_interpratation).trim()) { interp = p.test_interpratation; break; }
            if (p.test_interpretation_html && String(p.test_interpretation_html).trim()) { interp = p.test_interpretation_html; break; }
          }
        }

        return { ...rec, interpretation: interp ? String(interp) : "" };
      });

      // store raw list
      setFormData(prev => ({ ...prev, l1: normalized }));

      const uniquePatientsList = [...new Map(normalized.map(item => [item['lab_reg_id'], item])).values()];

      if (onlyToday) {
        const reqDateStr = toYMD(fromDate);
        const todays = uniquePatientsList.filter(p => {
          const pDateStr = toYMD(p.lab_reg_date || p.lab_reg_datetime || p.lab_reg_date_time || p.lab_reg_dt);
          return pDateStr && reqDateStr && pDateStr === reqDateStr;
        });

        setTodaysPatients(todays);
        setFilteredPatients(todays);
      } else {
        // full range
        setFilteredPatients(uniquePatientsList);
        setTodaysPatients([]);
        setSearchKey('');
        setSelectedUser(null);
        setFormData(prev => ({ ...prev, test_id0: '', l11: [] }));
      }
    } else {
      setFormData(prev => ({ ...prev, l1: [] }));
      setFilteredPatients([]);
      setTodaysPatients([]);
      setSearchKey('');
      setSelectedUser(null);
      setFormData(prev => ({ ...prev, test_id0: '', l11: [] }));
    }
  } catch (error) {
    console.error("getTests error:", error);
    toast.error("Failed to fetch test data.");
  } finally {
    setTimeout(() => setPatientsLoading(false), 150);
  }
};




  
  
  // keep filtered/today lists in sync whenever l1 updates
useEffect(() => {
  const uniq = [...new Map((formData.l1 || []).map(item => [item.lab_reg_id, item])).values()];

  setFilteredPatients(uniq);

  // build today's list (use formData.from if set, else today)
  const reqDateStr = formData.from ? parseToYMD(formData.from) : formatDateForInput(new Date());
  const todays = uniq.filter(p => {
    const pDateStr = toYMD(p.lab_reg_date || p.lab_reg_datetime || p.lab_reg_date_time || p.lab_reg_dt);
    return pDateStr && reqDateStr && pDateStr === reqDateStr;
  });
  setTodaysPatients(todays);
}, [formData.l1, formData.from]);


// const fetchTestParams = async (testId, testIndex) => {
//   // Guard: ensure l11 exists and index is valid
//   if (!Array.isArray(formData.l11) || typeof testIndex !== 'number' || !Number.isInteger(testIndex)) return;
//   if (!formData.l11[testIndex]) return; // nothing to fetch for

//   // If params already present, do nothing
//   if (Array.isArray(formData.l11[testIndex].params) && formData.l11[testIndex].params.length > 0) return;

//   const fd = new FormData();
//   fd.append('page_no', "none");
//   fd.append('search_key', "");
//   fd.append('test_id', testId);

//   try {
//     const response = await axios.post(AppConst.BASE_URL + AppConst.getTestParamListUrl, fd, {
//       headers: { 'Content-Type': 'multipart/form-data' },
//     });

//     const newParams = response.data.status
//       ? response.data.records.map(p => ({ ...p, result: '' }))
//       : [];

//     // Extra guard: double-check index still exists before writing
//     setFormData(prev => {
//       const updatedL11 = Array.isArray(prev.l11) ? [...prev.l11] : [];
//       if (!updatedL11[testIndex]) return prev; // index disappeared — do nothing
//       updatedL11[testIndex] = { ...updatedL11[testIndex], params: newParams };
//       return { ...prev, l11: updatedL11 };
//     });
//   } catch (err) {
//     toast.error("Failed to fetch parameters for the test.");
//     console.error("fetchTestParams error:", err);
//   }
// };

// place this near other functions (module-scope)
const _fetchInFlight = {}; // map testId => true

const fetchTestParams = async (testId) => {
  if (!testId) {
    console.warn("fetchTestParams: missing testId", testId);
    return;
  }
  if (_fetchInFlight[testId]) {
    // already fetching this id
    return;
  }
  _fetchInFlight[testId] = true;

  try {
    const fd = new FormData();
    fd.append('page_no', "none");
    fd.append('search_key', "");
    fd.append('test_id', testId);

    // debug
    console.debug("fetchTestParams: requesting", testId);

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.getTestParamListUrl,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 10000 } // 10s timeout
    );

    // debug: always log when inconsistent
    if (!response || !response.data) {
      console.warn("fetchTestParams: no response.data for", testId, response);
      toast.error("Failed to fetch parameter details (empty response).");
      return;
    }

    // safe extraction
    const success = !!response.data.status;
    const records = Array.isArray(response.data.records) ? response.data.records : [];

    if (!success || !records.length) {
      console.warn("fetchTestParams: server returned empty/unexpected for", testId, response.data);
      // don't show toast for every single missing param — optional
      // toast.error("Failed to fetch parameter details for test " + testId);
      // still update to empty params so UI will not keep trying forever
      setFormData(prev => {
        const updated = Array.isArray(prev.l11) ? prev.l11.map(t => {
          const id = t.lab_item_test_id ?? t.lab_item_parent ?? t.id ?? t.lab_item_id;
          if (String(id) === String(testId)) {
            return { ...t, params: [] };
          }
          return t;
        }) : prev.l11;
        return { ...prev, l11: updated };
      });
      return;
    }

    const newParams = records.map(p => ({ ...p, result: '' }));

    // update by id (robust to reordering)
    setFormData(prev => {
      if (!Array.isArray(prev.l11)) return prev;
      const updatedL11 = prev.l11.map(t => {
        const id = t.lab_item_test_id ?? t.lab_item_parent ?? t.id ?? t.lab_item_id;
        if (String(id) === String(testId)) {
          // only update if there aren't already params (avoid overwriting user edits)
          if (Array.isArray(t.params) && t.params.length > 0) return t;
          return { ...t, params: newParams };
        }
        return t;
      });
      return { ...prev, l11: updatedL11 };
    });

    console.debug("fetchTestParams: ok", testId, newParams.length, "params");
  } catch (err) {
    console.error("fetchTestParams error for", testId, err);
    // show a user-friendly message once
    toast.error("Failed to fetch parameters for the test. Please retry.");
  } finally {
    delete _fetchInFlight[testId];
  }
};


const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedUser) {
        toast.error("Please fill required fields.");
        return;
    }

    // Process formData.l11 to set empty results to null
    const processedL11 = formData.l11.map(test => {
      const newParams = test.params.map(param => ({
        ...param,
        result: param.result && param.result.trim() !== "" ? param.result : null
      }));

      // Also update impression and notes if they are in formData.l11
      return {
        ...test,
        params: newParams
      };
    });

    const fd = new FormData();
    fd.append('test_report_impression', formData.test_report_impression);  // Note: impression per test handled below
    fd.append('test_report_notes', formData.test_report_notes);
    fd.append('test_report_datetime', formData.test_report_datetime);
    fd.append('lab_reg_id', selectedUser.lab_reg_id);
    fd.append('items', JSON.stringify(processedL11));
    fd.append('test_report_user', ldata?.user_id);

    try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.addTestReportUrl, fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.data.status) {
            setIsReportSaved(true);
            toast.success("Report created successfully!");
            sessionStorage.removeItem("tst_dt");
        } else {
            toast.error("Failed to create report.");
        }
    } catch(error) {
        toast.error("Something went wrong during submission.", error);
    }
};


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleChange1 = (e, paramIndex, testIndex) => {
        const { value } = e.target;
        const pl = [...formData.l11];
        pl[testIndex].params[paramIndex].result = value;
        setFormData(prev => ({ ...prev, l11: pl }));
    };

    const handleSaveNext = (index) => {
        toast.success("Saved successfully");
        if (index < formData.l11.length - 1) {
            setActiveIndex(index + 1);
        }
    };

    const handleSearch = () => {
      if (!ldata) {
        toast.error("User not initialized.");
        return;
      }
    
      const fromY = parseToYMD(formData.from);
      const toY = parseToYMD(formData.to);
      if (!fromY || !toY) {
        toast.info("Please select From and To dates, then click Search.");
        return;
      }
    
      setPatientsLoading(true);
    
      // call getTests with parsed YYYY-MM-DD strings
      getTests(ldata.user_id, fromY, toY, false);
    
      // show results area
      setShowSearchDropdown(true);
    };
    
    
    
    

    const handleSearchInputChange = (e) => {
      const value = e.target.value;
      setSearchKey(value);
    
      if (value.trim() === '') {
        setSelectedUser(null);
        setFormData(prev => ({ ...prev, test_id0: '', l11: [] }));
        // show today's list if available, otherwise all patients
        setFilteredPatients(todaysPatients && todaysPatients.length ? todaysPatients : (
          [...new Map((formData.l1 || []).map(item => [item.lab_reg_id, item])).values()]
        ));
        setShowSearchDropdown(true);
        return;
      }
    
      setShowSearchDropdown(true);
    
      // derive patient list from current formData.l1 (not from a possibly stale variable)
      const sourceList = [...new Map((formData.l1 || []).map(item => [item.lab_reg_id, item])).values()];
      const filtered = sourceList.filter((item) =>
        (item.lab_reg_name || '').toLowerCase().includes(value.toLowerCase()) ||
        ((item.lab_reg_uhid || '').toLowerCase().includes(value.toLowerCase()))
      );
    
      setFilteredPatients(filtered);
    };
    
    
    const handleSearchKeyDown = (e) => {
      if (e.key === 'Backspace') {
        // If there is a selectedUser and the input currently shows that selection,
        // a single backspace should clear the selection and the input.
        if (selectedUser && searchKey) {
          e.preventDefault(); // avoid deleting characters from the label
          // clear UI and selection
          setSearchKey('');
          setSelectedUser(null);
          setFormData(prev => ({ ...prev, test_id0: '', l11: [] }));
          setSelectedTests(new Set());
          setSelectAllTests(false);
          setActiveIndex(null);
          setFilteredPatients(todaysPatients && todaysPatients.length ? todaysPatients : uniquePatients);
          setShowSearchDropdown(true);
          
        }
      }
    };
    

    const handlePatientSelect = (item) => {
      // Put the friendly label into the input and close dropdown
      setSearchKey(`${item.lab_reg_name} (${item.lab_reg_uhid})`);
      setShowSearchDropdown(false);
    
      // If sample not collected -> show SweetAlert and DO NOT load tests into l11
      const status = (item.lab_reg_status || '').toString().toLowerCase();
      if (status === 'pending' || status === 'sample not collected' || status === 'not collected') {
        // Show SweetAlert warning
        Swal.fire({
          icon: 'warning',
          title: 'Sample not collected',
          text: 'This patient\'s sample is not yet collected. You cannot create or edit report until the sample is collected.',
          confirmButtonText: 'OK'
        });
    
        // Still set selected user so patient details show, but clear test list
        setSelectedUser(item);
        setFormData(prev => ({ ...prev, test_id0: '', l11: [] }));
        return; // stop further processing
      }
    
      // Normal path: load tests for the selected patient
      setFormData(prev => ({
        ...prev,
        test_id0: item.lab_item_parent,
        l11: formData.l1
          .filter(i => i.lab_item_parent === item.lab_item_parent)
          .map(test => ({
            ...test,
            impression: '',
            notes: '',
            interpretation: (test.interpretation && String(test.interpretation).trim())
              ? test.interpretation
              : (test.params && test.params[0] && (test.params[0].test_interpratation || test.params[0].test_interpretation) ? (test.params[0].test_interpratation || test.params[0].test_interpretation) : '')
          }))
      }));
    
      setSelectedUser(item);
    };
    


    // replace existing get_param_val with this
const get_param_val = (tmp) => {
  if (!tmp) return "";

  const type = (tmp.test_param_type || "").trim();

  // Numeric -> show "from - to" but only if either exists
  if (type === "Numeric") {
    const from = tmp.test_param_from_range ?? "";
    const to = tmp.test_param_to_range ?? "";
    if (from === "" && to === "") return "";
    // show "from - to", but handle single-side ranges gracefully
    if (from !== "" && to !== "") return `${from} - ${to}`;
    if (from !== "") return `${from}`;
    return `${to}`;
  }

  // Boolean -> prefer server-provided labels, otherwise default to Yes / No
  if (type === "Boolean") {
    return tmp.test_param_from_range || "Yes / No";
  }

  // Editor / Text / other types -> show whatever is present, otherwise empty
  return tmp.test_param_from_range || "";
};


    const get_param_val1 = (tmp) => {
        if (tmp.test_param_type === "Numeric") return 1;
        if (tmp.test_param_type === "Boolean") return 2;
        return 3;
    };

    const uniquePatients = [...new Map(formData.l1.map(item => [item['lab_reg_id'], item])).values()];

    useEffect(() => {
      if (!formData.test_id0) {
        setSelectedUser(null);
        setFormData(prev => ({ ...prev, l11: [] }));
        return;
      }
      const tmp = formData.l1.filter(item => item.lab_item_parent === formData.test_id0);
      setSelectedUser(tmp[0] || null);
      setFormData(prev => ({ ...prev, l11: tmp }));
    }, [formData.test_id0, formData.l1]);

    // Safe effect to ensure missing params are fetched
useEffect(() => {
  if (!Array.isArray(formData.l11) || formData.l11.length === 0) return;

  formData.l11.forEach(test => {
    const testId = test.lab_item_test_id ?? test.lab_item_parent ?? test.id ?? test.lab_item_id;
    if (!testId) return;
    // only fetch if params missing/empty
    if (!Array.isArray(test.params) || test.params.length === 0) {
      fetchTestParams(testId);
    }
  });
}, [formData.l11]); // only depends on l11


    useEffect(() => {
      if (activeIndex === null) return;
      if (!Array.isArray(formData.l11) || !formData.l11[activeIndex]) return;
    
      const activeTest = formData.l11[activeIndex];
      if (!Array.isArray(activeTest.params) || activeTest.params.length === 0) {
        // fetch but do not rely on index being unchanged — fetchTestParams checks again before updating
        fetchTestParams(activeTest.lab_item_test_id, activeIndex);
      }
    }, [activeIndex, formData.l11]);
    
    useEffect(() => {
        if (!formData.test_id0) {
            setSelectedUser(null);
            setFormData(prev => ({ ...prev, l11: [] }));
            return;
        }

        const tmp = formData.l1.filter(item => item.lab_item_parent === formData.test_id0);
        setSelectedUser(tmp[0] || null);
        setFormData(prev => ({ ...prev, l11: tmp }));
    }, []);


    const handleBlur = () => {
        setTimeout(() => {
            if (
                document.activeElement !== inputRef.current &&
                !dropdownRef.current?.contains(document.activeElement)
            ) {
                setShowSearchDropdown(false);
            }
        }, 100);
    };


    const isAllResultsFilled = (params) => {
        if (!params) return false;
        return params.every(param => param.result && param.result.toString().trim() !== '');
    };
    
    // =================================================================================
    // NEW PDF GENERATION LOGIC
    // =================================================================================

    // Function to check if a value is outside the normal range
    const isAbnormal = (result, normalRange, gender) => {
        if (!result || !normalRange) return false;
        
        const numResult = parseFloat(result);
        if (isNaN(numResult)) return false;

        // Simple range like "4000-11000"
        let rangeStr = normalRange;

        // Handle gender-specific ranges like "M:12-18 F:11.5-15.5"
        if (normalRange.includes("M:") && gender) {
            const genderChar = gender.charAt(0).toUpperCase();
            const ranges = normalRange.split(' ');
            const relevantRange = ranges.find(r => r.startsWith(genderChar + ":"));
            if (relevantRange) {
                rangeStr = relevantRange.substring(2);
            }
        }

        const rangeParts = rangeStr.match(/(\d+\.?\d*)-(\d+\.?\d*)/);
        if (rangeParts && rangeParts.length === 3) {
            const lower = parseFloat(rangeParts[1]);
            const upper = parseFloat(rangeParts[2]);
            return numResult < lower || numResult > upper;
        }

        return false;
    };
    
       const initData2 = async () => {
            const storedData = sessionStorage.getItem("ldata");
 const storedDataF = JSON.parse(sessionStorage.getItem("ldata") || "{}");
// console.log("session data :", storedDataF);

setName(
  [storedDataF?.fname, storedDataF?.lname].filter(Boolean).join(" ")
);
            if (storedData) {
                const parsed = JSON.parse(storedData);
                const fd = new FormData();
                fd.append('cat_type', "department");
                fd.append('page_no', "none");
                fd.append('search_key', "");
                fd.append('par_by', 1 + "");
    
                try {
                    const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd);
                    if (response.data.status && response.data.records) {
                        setFormData(prev => ({
                            ...prev,
                            departs: response.data.records
                        }));

                    }
                } catch (error) {
                    console.error(error);
                }
            }
        };

        // console.log("department : " + JSON.stringify(formData.departs))

        const fetchSignConfigData = async () => {
          if (!Array.isArray(formData.departs) || formData.departs.length === 0) return;
          try {
            const allSignData = {};
            const allPreviews = {};
        
            // sequential requests (safer than Promise.all for many items)
            for (const dep of formData.departs) {
              try {
                const fd = new FormData();
                fd.append('sign_department', String(dep.cat_id));
                const res = await axios.post(AppConst.BASE_URL + AppConst.getSignByDepartUrl, fd);
                if (res.data && res.data.status && res.data.sign_dt) {
                  allSignData[dep.cat_id] = res.data.sign_dt;
                  allPreviews[dep.cat_id] = {
                    tech: res.data.sign_dt.sign_tech_sign ? AppConst.BASE_URL + res.data.sign_dt.sign_tech_sign : null,
                    doc: res.data.sign_dt.sign_doc_sign ? AppConst.BASE_URL + res.data.sign_dt.sign_doc_sign : null
                  };
                }
                // small pause to avoid overwhelming server/browser (optional)
                await new Promise(r => setTimeout(r, 50));
              } catch (innerErr) {
                console.warn('fetchSignConfigData: failed for dep', dep.cat_id, innerErr);
                // continue on error
              }
            }
        
            setFormData(prev => ({ ...prev, selItem: allSignData }));
          } catch (err) {
            console.error('fetchSignConfigData: unexpected error', err);
          }
        };
        


// console.log("formData:", JSON.stringify(formData.selItem));
     
const fetchConfigData = async () => {
  try {
    const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
    if (res.data && res.data.status) {
      setImage(res.data.header_logo || '');
      setWatermarkImage(res.data.logo || '');
      setFooterImage(res.data.footer_logo || '');
    } else {
      console.warn('fetchConfigData: config endpoint returned ok but status false', res.data);
    }
  } catch (err) {
    console.error("Error fetching config:", err);
    // show user-friendly message once (don't spam on repeated effects)
    toast.warn("Config images unavailable — continuing without header/footer.");
  }
};

    
    // fetch config once on mount
useEffect(() => {
  fetchConfigData();
  // initData2() is already called in another effect; avoid duplicates
}, []);

// fetch sign config only when departments list is populated
useEffect(() => {
  if (!formData.departs || formData.departs.length === 0) return;
  // call sign fetcher (see throttled version below)
  fetchSignConfigData();
}, [formData.departs]);

     
    
const _imageCache = {}; // module-level cache

const imageUrlToBase64 = async (url) => {
  if (!url) return null;
  if (_imageCache[url]) return _imageCache[url]; // return cached

  try {
    // optional: ensure URL is absolute and same origin if possible, or proxy via server
    const response = await fetch(url, { cache: 'no-cache', mode: 'cors' });
    if (!response.ok) {
      console.error(`image fetch failed: ${url}`, response.status);
      return null;
    }
    const blob = await response.blob();
    if (!blob.type.startsWith('image/')) return null;
    const result = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    _imageCache[url] = result;
    return result;
  } catch (err) {
    console.error("imageUrlToBase64 error (likely CORS or network):", url, err);
    return null;
  }
};




    const formatCellValue = (htmlString) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    // Agar table hai to manually cell text banao
    const table = tempDiv.querySelector("table");
    if (table) {
        
        let rows = [];
        for (const tr of table.querySelectorAll("tr")) {
            let cells = [];
            for (const td of tr.querySelectorAll("td")) {
                cells.push(td.innerText.trim());
            }
            rows.push(cells.join(" | ")); // table ke cells ko " | " se separate
        }
        return rows.join("\n"); // rows ko newline se separate
    }

    // Agar simple HTML hai to text return karo
    return tempDiv.innerText.trim();
};

const addHeaderAndFooter = async (doc) => {
  const pageWidth = typeof doc.internal.pageSize.getWidth === 'function' ? doc.internal.pageSize.getWidth() : doc.internal.pageSize.width;
  const pageHeight = typeof doc.internal.pageSize.getHeight === 'function' ? doc.internal.pageSize.getHeight() : doc.internal.pageSize.height;

  // Watermark: guard GState usage
  try {
    const watermarkBase64 = await imageUrlToBase64(watermarkImage);
    if (watermarkBase64 && typeof doc.setGState === 'function') {
      doc.setGState(new doc.GState ? new doc.GState({ opacity: 0.08 }) : { opacity: 0.08 });
      doc.addImage(watermarkBase64, 'PNG', (pageWidth - 120) / 2, (pageHeight - 120) / 2, 120, 120);
      if (typeof doc.setGState === 'function') doc.setGState(new doc.GState ? new doc.GState({ opacity: 1 }) : { opacity: 1 });
    }
  } catch (e) {
    console.warn('watermark add failed', e);
  }

  // Header/footer images: use try/catch and only add if base64 exists
  try { const headerImageBase64 = await imageUrlToBase64(image); if (headerImageBase64) doc.addImage(headerImageBase64, 0, 0, pageWidth, 30); } catch(e) { console.warn('header add failed', e); }
  try { const footerImageBase64 = await imageUrlToBase64(footerImage); if (footerImageBase64) doc.addImage(footerImageBase64, 0, pageHeight - 13, pageWidth, 13); } catch(e) { console.warn('footer add failed', e); }
};


const formatDateTime12h = (dateTimeStr) => {
  if (!dateTimeStr) return "";
  try {
    const d = new Date(dateTimeStr);
    if (isNaN(d.getTime())) return dateTimeStr;
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}-${month}-${year} ${String(hours).padStart(2,"0")}:${minutes}:${seconds} ${ampm}`;
  } catch (e) {
    console.warn("formatDateTime12h failed:", e);
    return dateTimeStr;
  }
};
// Helper: format Date -> YYYY-MM-DD for <input type="date">
const formatDateForInput = (d = new Date()) => {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Robust parser: accepts "DD/MM/YYYY", "DD-MM-YYYY", "YYYY-MM-DD", timestamps, Date objects.
// Returns YYYY-MM-DD or '' if cannot parse.
const parseToYMD = (val) => {
  if (!val && val !== 0) return '';
  if (val instanceof Date && !isNaN(val.getTime())) return formatDateForInput(val);

  const s = String(val).trim();
  // YYYY-MM-DD or YYYY/MM/DD
  let m = s.match(/^(\d{4})[\/-](\d{2})[\/-](\d{2})/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;

  // DD/MM/YYYY or DD-MM-YYYY -> convert to YYYY-MM-DD
  m = s.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;

  // Last resort: Date parse
  const dt = new Date(s);
  if (!isNaN(dt.getTime())) return formatDateForInput(dt);

  return '';
};

// --- Helper: safe rect to avoid invalid-args exception
const safeRect = (doc, xRaw, yRaw, wRaw, hRaw) => {
  const x = Number(xRaw), y = Number(yRaw), w = Number(wRaw), h = Number(hRaw);
  const ok = [x, y, w, h].every(v => Number.isFinite(v));
  if (ok) {
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.2);
    doc.rect(x, y, w, h);
  } else {
    console.warn("safeRect: skipping rect due to invalid args", { xRaw, yRaw, wRaw, hRaw, parsed: { x, y, w, h } });
  }
};

// --- Drop-in: robust async printPatientDetails (use await when calling) ---
const printPatientDetails = async (doc, patient = {}, startY = 40) => {
  try {
    // Basic validations
    if (!doc || !doc.internal) {
      console.error("printPatientDetails: invalid doc", doc);
      return Number(startY) || 12;
    }
    // Ensure startY numeric
    startY = Number(startY);
    if (!isFinite(startY)) startY = 40;

    // Robust pageWidth detection for different jsPDF versions
    let pageWidthRaw;
    try {
      pageWidthRaw = typeof doc.internal.pageSize.getWidth === 'function'
        ? doc.internal.pageSize.getWidth()
        : doc.internal.pageSize.width;
    } catch (e) {
      pageWidthRaw = doc.internal.pageSize && doc.internal.pageSize.width;
    }
    const pageWidth = Number(pageWidthRaw);
    const PAGE_WIDTH = isFinite(pageWidth) ? pageWidth : 210; // fallback

    // Box geometry (numbers)
    const boxLeft = 10;
    const boxTop = startY - 2; // small margin
    const boxWidth = PAGE_WIDTH - boxLeft * 2;
    const boxHeight = 24; // adjust if you need more space

    // Draw outer box safely
    safeRect(doc, boxLeft, boxTop, boxWidth, boxHeight);

    // Optionally draw header logo on left (if imageUrlToBase64 exists and image state holds url)
    try {
      // if (typeof imageUrlToBase64 === "function" && image) {
      //   const logoBase64 = await imageUrlToBase64(image);
      //   if (logoBase64) {
      //     const logoH = Math.min(34, boxHeight - 8);
      //     const logoW = logoH; // square logo; change if needed
      //     const logoX = boxLeft + 6;
      //     const logoY = boxTop + 6;
      //     if ([logoX, logoY, logoW, logoH].every(v => isFinite(v))) {
      //       doc.addImage(logoBase64, "PNG", logoX, logoY, logoW, logoH);
      //     }
      //   }
      // }
    } catch (e) {
      console.warn("printPatientDetails: logo draw failed (CORS/URL)", e);
    }

    // QR: vertically centered inside the box and at right
    const qrSize = 20;
    const qrX = boxLeft + boxWidth - qrSize - 3;
    const qrY = boxTop + (boxHeight - qrSize) / 10;
    try {
      const qrText = `${patient.lab_reg_uhid || ''} | ${patient.lab_reg_name || ''}`;
      const qrDataUrl = await QRCode.toDataURL(qrText, { width: 200 });
      if (qrDataUrl && [qrX, qrY, qrSize].every(v => isFinite(v))) {
        doc.addImage(qrDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
      } else {
        console.warn("printPatientDetails: QR coords invalid", { qrX, qrY, qrSize });
      }
    } catch (e) {
      console.warn("printPatientDetails: QR generation failed", e);
    }

    // Prepare formatted values
    const dateParts = String(patient.lab_reg_date || "").split("-");
    const formattedDate = (dateParts.length >= 3) ? `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}` : (patient.lab_reg_date || "");
    const reportedOn = formatDateTime12h(formData?.test_report_datetime || new Date().toISOString());
    const printedOn = formatDateTime12h(new Date().toISOString());
    

    // Text columns (left and right labels/values)
    const leftColLabel = boxLeft + 4;
    const leftColValue = leftColLabel + 36;
    const rightColLabel = boxLeft + Math.round(boxWidth * 0.5) + 4;
    const rightColValue = rightColLabel + 36;

    // Start writing inside box — choose start row
    let yPos = boxTop + 5;
    doc.setFontSize(10);

    doc.setFont('helvetica', 'bold'); doc.text("UHID", leftColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${patient.lab_reg_uhid || ''}`, leftColValue, yPos);
    doc.setFont('helvetica', 'bold'); doc.text("Patient ID", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: 00${patient.lab_reg_id || ''}`, rightColValue, yPos);
    yPos += 4;

    doc.setFont('helvetica', 'bold'); doc.text("Patient Name", leftColLabel, yPos);
const titlePrefix = patient.lab_reg_name_title ? String(patient.lab_reg_name_title).trim() + ' ' : '';
doc.setFont('helvetica', 'normal');
doc.text(`: ${titlePrefix}${patient.lab_reg_name || ''}`, leftColValue, yPos);

    doc.setFont('helvetica', 'bold'); doc.text("Registered On", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${formattedDate}`, rightColValue, yPos);
    yPos += 4;

    doc.setFont('helvetica', 'bold');
    doc.text("Age / Gender", leftColLabel, yPos);
    doc.setFont('helvetica', 'normal');
    doc.text(`: ${getAgeDisplay(patient)} / ${patient.lab_reg_gender || ''}`, leftColValue, yPos);
    
    doc.setFont('helvetica', 'bold'); doc.text("Collected At", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${patient.lab_collected_at || ''}`, rightColValue, yPos);
    yPos += 4;

    doc.setFont('helvetica', 'bold'); doc.text("Referred By", leftColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${patient.lab_reg_referral || 'N/A'}`, leftColValue, yPos);
    doc.setFont('helvetica', 'bold'); doc.text("Sample Collected By", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${Name || ''}`, rightColValue, yPos);
    yPos += 4;

    doc.setFont('helvetica', 'bold'); doc.text("Reported On", leftColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${reportedOn}`, leftColValue, yPos);
    doc.setFont('helvetica', 'bold'); doc.text("Printed On", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${printedOn}`, rightColValue, yPos);
    yPos += 4;

    // Return the Y position after the box so caller can continue
    return boxTop + boxHeight + 10;
  } catch (err) {
    console.error("printPatientDetails: unexpected error", err);
    return Number(startY) + 9;
  }
};


async function addSignatures(doc, signData) {
    const finalY = doc.internal.pageSize.getHeight() - 45;

    console.log("sign " +JSON.stringify(signData))

    if (!signData) return;

    // ==== Left: Lab Technician ====
    if (signData.sign_tech_sign ) {
        if (signData.sign_tech_sign) {
            const techSignBase64 = await imageUrlToBase64(AppConst.BASE_URL + signData.sign_tech_sign);
            if (techSignBase64) {
                doc.addImage(techSignBase64, 'PNG', 14, finalY, 30, 15);
            }
        }
        if (signData.sign_tech_name) {
            const techName = signData.sign_tech_name || '';
            const techId = signData?.sign_tech_id ? ` (${signData.sign_tech_id})` : '';
            doc.setFontSize(9).setFont('helvetica', 'normal').text(`${techName}${techId}`, 14, finalY + 20);
            doc.setFontSize(9).setFont('helvetica', 'bold').text("Lab Technician", 14, finalY + 24);
        }
    }

    // ==== Right: Authorized Doctor ====
    if (signData.sign_doc_sign || signData.sign_doc_name) {
        if (signData.sign_doc_sign) {
            const docSignBase64 = await imageUrlToBase64(AppConst.BASE_URL + signData.sign_doc_sign);
            if (docSignBase64) {
                doc.addImage(docSignBase64, 'PNG', 166, finalY, 30, 15);
            }
        }
        if (signData.sign_doc_name) {
            const docName = signData.sign_doc_name || '';
            const docId = signData?.sign_doc_id ? ` (${signData.sign_doc_id})` : '';
            doc.setFontSize(11).setFont('helvetica', 'bold').text(`${docName}${docId}`, 196, finalY + 20, { align: 'right' });

            // ✅ Pathologist vs Consultant text
            const designation = (signData.sign_department === '60') ? "Consultant" : "Consultant Pathologist";
            doc.setFontSize(9).setFont('helvetica', 'bold').text(designation, 196, finalY + 24, { align: 'right' });
        }
    }
}




const drawHtmlContent = async (doc, htmlString, initialX, initialY, options) => {
    const { maxWidth, addNewPage, pageHeight, pageBuffer } = options;
    let x = initialX;
    let y = initialY;

    // Use a style stack to handle nested formatting (e.g., <b><i>text</i></b>)
    const styleStack = [{ font: 'helvetica', style: 'normal', size: 9 }];

    const applyStyle = () => {
        const currentStyle = styleStack[styleStack.length - 1];
        doc.setFontSize(currentStyle.size);
        doc.setFont(currentStyle.font, currentStyle.style);
    };
    
    // This recursive function will parse the DOM nodes
    const parseNodes = async (nodes) => {
        for (const node of nodes) {
            if (y > pageHeight - pageBuffer) {
                y = await addNewPage();
            }

            if (node.nodeType === 3) { // Text node
                const text = node.nodeValue.trim();
                if (!text) continue;

                const words = text.split(/\s+/);
                for (const word of words) {
                    const wordWidth = doc.getTextWidth(word + ' ');
                    if (x + wordWidth > initialX + maxWidth) {
                        x = initialX;
                        y += 5; // Line height
                         if (y > pageHeight - pageBuffer) {
                            y = await addNewPage();
                        }
                    }
                    applyStyle();
                    doc.text(word, x, y);
                    x += wordWidth;
                }
                 // Add a space after a text segment if it's not the end of a block
                if (x > initialX) {
                     x += doc.getTextWidth(' ');
                }


            } else if (node.nodeType === 1) { // Element node
                const tagName = node.tagName.toUpperCase();
                let newStyle = { ...styleStack[styleStack.length - 1] };
                let isBlockElement = false;

                switch (tagName) {
                    case 'STRONG':
                    case 'B':
                        newStyle.style = 'bold';
                        break;
                    case 'EM':
                    case 'I':
                        newStyle.style = 'italic';
                        break;
                    case 'P':
                        if (x > initialX) { // Newline before starting a paragraph
                           y += 8;
                           x = initialX;
                        }
                        isBlockElement = true;
                        break;
                    case 'LI':
                        if (x > initialX) { // Newline before list item
                           y += 6;
                        }
                         x = initialX;
                        applyStyle();
                        doc.text('• ', x, y);
                        x += 5;
                        isBlockElement = true;
                        break;
                    case 'UL':
                    case 'OL':
                         if (x > initialX) {
                           y += 8;
                           x = initialX;
                         }
                         isBlockElement = true;
                         break;
                }

                styleStack.push(newStyle);
                await parseNodes(node.childNodes);
                styleStack.pop();
                
                if (isBlockElement) {
                     x = initialX; // Reset X for next element
                     y += 5; // Add some space after block elements
                }
            }
        }
    };
    
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    await parseNodes(tempDiv.childNodes);

    return y; // Return the final y position
};



// helper: returns formatted age text or 'N/A'
// returns formatted age with plural 's' when >1, or 'N/A' if all zero
const getAgeDisplay = (p) => {
  if (!p) return 'N/A';
  const y = Number(p.lab_reg_age_year || 0);
  const m = Number(p.lab_reg_age_month || 0);
  const d = Number(p.lab_reg_age_day || 0);

  if (y === 0 && m === 0 && d === 0) return 'N/A';

  const parts = [];
  if (y > 0) parts.push(`${y}Y${y > 1 ? 's' : ''}`);
  if (m > 0) parts.push(`${m}M${m > 1 ? 's' : ''}`);
  if (d > 0) parts.push(`${d}D${d > 1 ? 's' : ''}`);

  return parts.join(' ');
};


const generatePdfForTests = async (testsToPrint) => {
    console.log("generated pdf :" + JSON.stringify(testsToPrint));
    const doc = new jsPDF();
    const patient = selectedUser;
    let hasRadiology = false; 

    try {
      const fontBase64 = await loadFontAsBase64("/DejaVuSans.ttf"); // adjust path as needed
      doc.addFileToVFS("DejaVuSans.ttf", fontBase64);
      doc.addFont("DejaVuSans.ttf", "DejaVu", "normal");
      doc.setFont("DejaVu");
  } catch (error) {
      console.error("Font loading failed:", error);
      toast.error("Font loading failed. Arrows may not display correctly.");
  }
  
  if (!patient) {
      toast.error("No patient selected!");
      return;
  }

    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageBuffer = 35;

const addNewPage = async () => {
    doc.addPage();
    await addHeaderAndFooter(doc);
    return  await printPatientDetails(doc, patient, 35);  // ✅ Har new page pe patient details
};


    // --- First Page Setup ---
    await addHeaderAndFooter(doc);
    let yPos = await printPatientDetails(doc, patient, 35);
    let lastPrintedDept = null;

    // Helper function to draw the main parameter table to avoid repeating code
   // make drawMainTable async and await addNewPage when needed
const drawMainTable = async (rows, needsHead) => {
  if (rows.length <= 1) return; // Agar sirf main test name hai to table na banaye

  const tableHeightEstimate = rows.length * 8 + (needsHead ? 10 : 0);
  if (yPos + tableHeightEstimate > pageHeight - pageBuffer) {
      // await here: addNewPage is async and returns new yPos
      yPos = await addNewPage();
      needsHead = true;
  }

  await autoTable(doc, {
    startY: yPos,
    head: needsHead ? [["TEST NAME", "RESULT", "UNITS", "NORMAL RANGES", "METHOD"]] : null,
    body: rows,
    theme: 'plain',
    headStyles: { fillColor: [180, 220, 250], textColor: 0, fontStyle: 'bold', halign: 'center' },
    styles: { fontSize: 9, cellPadding: 2, valign: 'middle' },
    // Adjusted widths: give more room to METHOD (index 4)
    columnStyles: {
      0: { cellWidth: 48 },   // TEST NAME
      1: { cellWidth: 38, halign: 'center' }, // RESULT
      2: { cellWidth: 22, halign: 'center' }, // UNITS
      3: { cellWidth: 40, halign: 'center' }, // NORMAL RANGES
      4: { cellWidth: 43, halign: 'center' }  // METHOD (wider)
    },
    margin: { left: 10, right: 10 },
    didDrawCell: (data) => {
        if (data.section === 'body' && data.row.index === 0 && data.cell.raw.isMainTest) {
            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(0.2);
            const textWidth = doc.getTextWidth(data.cell.text[0]);
            const lineY = data.cell.y + data.cell.height - 1.5;
            doc.line(data.cell.x + 2, lineY, data.cell.x + 2 + textWidth, lineY);
        }
    }
});

  // ensure doc.lastAutoTable is available (autoTable populates it)
  yPos = (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 4 : yPos + 4;
};


    // ==== Main Loop for Tests ====
    for (const test of testsToPrint) {
        // --- Department Heading Logic ---
        const departmentMap = {};
        (formData.departs || []).forEach(d => { departmentMap[d.cat_id] = d.cat_name; });
        let deptName = "HEMATOLOGY";
        if (test.params && test.params.length > 0) {
            deptName = departmentMap[test.params[0].test_cat] || null;
        }

        if (deptName && deptName.toLowerCase() === "radiology") {
        hasRadiology = true;  // 👈 Agar radiology mila to flag true
    }

        let addTableHead = false;
        if (deptName && deptName !== lastPrintedDept) {
            if (yPos + 15 > pageHeight - pageBuffer) { yPos = await addNewPage(); }
            doc.setFillColor(180, 220, 250);
            doc.rect(10, yPos - 5, 190, 8, 'FD');
            doc.setFontSize(12).setFont('helvetica', 'bold').setTextColor(0, 0, 0);
            doc.text(deptName, 105, yPos, { align: 'center' });
            yPos += 5;
            lastPrintedDept = deptName;
            addTableHead = true;
        }

        let paramsRows = [];
        // Main Test Name ko har table ke start me add karenge
        const mainTestNameRow = [{
            content: test.lab_item_test_name,
            colSpan: 5,
            styles: { fontStyle: 'bold', textColor: [0, 0, 0], cellPadding: { top: 2, bottom: 2, left: 2 } },
            isMainTest: true // Custom flag for underline logic
        }];
        paramsRows.push(mainTestNameRow);

        let hasResultInCurrentTable = false;

        // ==========================================================
        // ===== START: YAHAN SE LOGIC POORA UPDATE KIYA GAYA HAI =====
        // ==========================================================

       
        
        for (const param of test.params) {
          // compute pdf-friendly name and starred flag per param
          const rawParamName = String(param.test_param_name || "");
          const isPdfStarred = /^\*.+\*$/.test(rawParamName.trim());
          const pdfParamName = isPdfStarred ? rawParamName.trim().replace(/^\*(.+)\*$/, '$1') : rawParamName;
        
          // ---------- Editor-type parameter (rich HTML content) ----------
          // if (param.test_param_type === "Editor") {
          //   // Draw any pending numeric/text parameter table before rendering editor content
          //   if (hasResultInCurrentTable) {
          //     drawMainTable(paramsRows, addTableHead);
          //     paramsRows = [mainTestNameRow];
          //     hasResultInCurrentTable = false;
          //     addTableHead = true;
          //   }
        
          //   // Ensure heading is printed for Editor param even if content is empty
          //   if (yPos + 10 > pageHeight - pageBuffer) { yPos = await addNewPage(); }
          //   doc.setFontSize(10);
          //   doc.setFont('helvetica', isPdfStarred ? 'bold' : 'normal');
          //   doc.text(pdfParamName, 16, yPos);
          //   yPos += 6;
        
          //   // Render editor content if present
          //   const editorContent = String(param.result || "").trim();
          //   if (editorContent) {
          //     // extract any table present in the editor content
          //     const tempDiv = document.createElement("div");
          //     tempDiv.innerHTML = editorContent;
          //     const tableElement = tempDiv.querySelector("table");
          //     const htmlContentToRender = (() => {
          //       if (!tableElement) return tempDiv.innerHTML;
          //       // remove the table from the html so we render it separately
          //       const cloned = tempDiv.cloneNode(true);
          //       const tbl = cloned.querySelector("table");
          //       if (tbl) tbl.remove();
          //       return cloned.innerHTML;
          //     })();
        
          //     // Render remaining HTML (text, lists, paragraphs)
          //     if (htmlContentToRender && String(htmlContentToRender).trim()) {
          //       yPos = await drawHtmlContent(doc, htmlContentToRender, 16, yPos, {
          //         maxWidth: 178,
          //         addNewPage,
          //         pageHeight,
          //         pageBuffer
          //       });
          //       yPos += 4;
          //     }
        
          //     // Render table separately if exists
          //     if (tableElement) {
          //       if (yPos + 12 > pageHeight - pageBuffer) yPos = await addNewPage();
          //       try {
          //         autoTable(doc, {
          //           startY: yPos,
          //           html: tableElement,
          //           theme: "grid",
          //           styles: { fontSize: 9, cellPadding: 2, valign: "middle" },
          //           margin: { left: 14, right: 14 }
          //         });
          //         yPos = doc.lastAutoTable ? doc.lastAutoTable.finalY + 6 : yPos + 17;
          //       } catch (err) {
          //         // fallback: convert table manually
          //         const rows = [];
          //         tableElement.querySelectorAll("tr").forEach(tr => {
          //           const cols = [];
          //           tr.querySelectorAll("th, td").forEach(td => cols.push((td.innerText||'').trim()));
          //           rows.push(cols);
          //         });
          //         if (rows.length) {
          //           if (yPos + rows.length * 8 > pageHeight - pageBuffer) yPos = await addNewPage();
          //           autoTable(doc, {
          //             startY: yPos,
          //             body: rows,
          //             theme: "grid",
          //             styles: { fontSize: 9, cellPadding: 2, valign: "middle" },
          //             margin: { left: 14, right: 14 }
          //           });
          //           yPos = doc.lastAutoTable.finalY + 6;
          //         }
          //       }
          //     }
          //   }
        
          //   // small gap after Editor param
          //   yPos += 4;
          //   continue; // move to next param
          // } // end Editor branch
        
        // ---------- Editor-type parameter (rich HTML content) ----------
if (param.test_param_type === "Editor") {
  // If there are any pending numeric rows, flush them first
  if (hasResultInCurrentTable) {
    drawMainTable(paramsRows, addTableHead);
    paramsRows = [mainTestNameRow];
    hasResultInCurrentTable = false;
    addTableHead = true;
  }

  // Ensure there's a bit more gap before the editor param (makes the "gap" after dept heading)
  if (yPos + 12 > pageHeight - pageBuffer) { yPos = await addNewPage(); }
  yPos += 4; // small extra gap

  // Print the parameter name as a bold subheading (always bold for Editor params)
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  // use left padding consistent with other content
  doc.text(pdfParamName, 16, yPos);
  yPos += 7;

  // Render editor content if present (same logic as before)
  const editorContent = String(param.result || "").trim();

  if (editorContent) {
    // extract any table present in the editor content
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = editorContent;
    const tableElement = tempDiv.querySelector("table");
    const htmlContentToRender = (() => {
      if (!tableElement) return tempDiv.innerHTML;
      // remove the table from the html so we render it separately
      const cloned = tempDiv.cloneNode(true);
      const tbl = cloned.querySelector("table");
      if (tbl) tbl.remove();
      return cloned.innerHTML;
    })();

    // Render remaining HTML (text, lists, paragraphs)
    if (htmlContentToRender && String(htmlContentToRender).trim()) {
      yPos = await drawHtmlContent(doc, htmlContentToRender, 16, yPos, {
        maxWidth: 178,
        addNewPage,
        pageHeight,
        pageBuffer
      });
      yPos += 4;
    }

    // Render table separately if exists
    if (tableElement) {
      if (yPos + 12 > pageHeight - pageBuffer) yPos = await addNewPage();
      try {
        autoTable(doc, {
          startY: yPos,
          html: tableElement,
          theme: "grid",
          styles: {
            fontSize: 9,
            cellPadding: 2,
            valign: "middle",
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            lineWidth: 0.2
          },
          headStyles: {
            textColor: [0, 0, 0],
            fillColor: [255, 255, 255],
            fontStyle: 'bold'
          },
          margin: { left: 14, right: 14 }
        });
        
        yPos = doc.lastAutoTable ? doc.lastAutoTable.finalY + 6 : yPos + 17;
      } catch (err) {
        // fallback: convert table manually
        const rows = [];
        tableElement.querySelectorAll("tr").forEach(tr => {
          const cols = [];
          tr.querySelectorAll("th, td").forEach(td => cols.push((td.innerText||'').trim()));
          rows.push(cols);
        });
        if (rows.length) {
          if (yPos + rows.length * 8 > pageHeight - pageBuffer) yPos = await addNewPage();
          autoTable(doc, {
            startY: yPos,
            body: rows,
            theme: "grid",
            styles: { fontSize: 9, cellPadding: 2, valign: "middle" },
            margin: { left: 14, right: 14 }
          });
          yPos = doc.lastAutoTable.finalY + 6;
        }
      }
    }
  } else {
    // if no content, leave small gap so the bold param name is visible as a header-only entry
    yPos += 4;
  }

  // small gap after Editor param
  yPos += 6;
  continue; // move to next param
}

          // ---------- Non-Editor param (numeric/text/boolean) ----------
          // If param has no result and is not starred, skip it (keeps previous behavior).
          // But if param is starred, include it even if result is empty (as a row with empty result).
          const hasResult = param.result !== undefined && param.result !== null && String(param.result).trim() !== "";
          if (!hasResult && !isPdfStarred) {
            continue;
          }
        
          // If we reach here, we will add this param to paramsRows (either hasResult or isPdfStarred)
          let resultWithFlag = hasResult ? String(param.result).trim() : ""; // empty string for no result
          let resultStyles = { halign: 'center', textColor: [0, 0, 0] };
        
          // only try numeric flagging when there's a numeric result and a numeric range

          //report result type H and Low showing.. 
          
        // if result high/low no symbol
// if (hasResult) {
//   const rangeValue = formatCellValue(get_param_val(param));
//   const match = String(rangeValue).match(/([\d.]+)\s*-\s*([\d.]+)/);
//   if (match) {
//     const min = parseFloat(match[1]);
//     const max = parseFloat(match[2]);
//     const resultNum = parseFloat(resultWithFlag);
//     if (!isNaN(resultNum)) {
//       if (resultNum > max || resultNum < min) {
//         // 👇 Just bold abnormal values — no color, no H/L
//         resultStyles = { ...resultStyles, fontStyle: 'bold' };
//       }
//     }
//   }
// }

          // push row using pdfParamName (ensures bold label in PDF when table renders via didDrawCell)

          // only try numeric flagging when there's a numeric result and a numeric range
if (hasResult) {
  const rangeValue = formatCellValue(get_param_val(param));
  const match = String(rangeValue).match(/([\d.]+)\s*-\s*([\d.]+)/);
  if (match) {
    const min = parseFloat(match[1]);
    const max = parseFloat(match[2]);
    const resultNum = parseFloat(resultWithFlag);
    if (!isNaN(resultNum)) {
      if (resultNum > max) {
        // High: add up arrow ↑
        resultWithFlag = `${resultWithFlag} H`;
        resultStyles = { ...resultStyles, fontStyle: 'bold', textColor: [0, 0, 0] }; // red and bold
      } else if (resultNum < min) {
        // Low: add down arrow ↓
        resultWithFlag = `${resultWithFlag} L`;
        resultStyles = { ...resultStyles, fontStyle: 'bold', textColor: [0, 0, 0] }; // blue and bold
      }
      // else: within range, no arrow, normal style
    }
  }
}
          paramsRows.push([
            //pdfParamName,
            { content: pdfParamName, styles: isPdfStarred ? { fontStyle: 'bold' } : {} },
            { content: resultWithFlag || "", styles: resultStyles },
            param.test_range_type || "",
            formatCellValue(get_param_val(param)) || "",
            param.test_param_method || ""
          ]);
        
          hasResultInCurrentTable = true;
        } // end param loop
        
        
        // ==========================================================
        // ===== END: LOGIC UPDATE KHATAM HUA =======================
        // ==========================================================

        // Loop ke baad agar koi normal parameters bache hain, to unki table bana do
        if (hasResultInCurrentTable) {
          await drawMainTable(paramsRows, addTableHead);
      }
      

        // --- Sample Type, Interpretation, Notes Sections (Ye waise hi rahenge) ---
        // if (test.params[0]?.test_sample_type) {
        //     autoTable(doc, {
        //         startY: yPos,
        //         body: [[{ content: `Sample Type : ${test.params[0]?.test_sample_type}`, colSpan: 5, styles: { fontStyle: 'bold', textColor: [80, 80, 80] } }]],
        //         theme: 'plain',
        //         styles: { fontSize: 8, cellPadding: 1, valign: 'middle' },
        //         margin: { left: 14, right: 14 },
        //     });
        //     yPos = doc.lastAutoTable.finalY + 6;
        // }



        // === Sample Type: Skip for Radiology ===
// deptName is set earlier in the loop: departmentMap[test.params[0].test_cat] || null
const isRadiologyDept = (deptName && String(deptName).toLowerCase() === 'radiology') 
|| (test.params[0] && String(test.params[0].test_cat) === '60'); // fallback by category id

if (!isRadiologyDept && test.params[0]?.test_sample_type) {
autoTable(doc, {
    startY: yPos,
    body: [[{ 
        content: `Sample Type : ${test.params[0]?.test_sample_type}`, 
        colSpan: 5, 
        styles: { fontStyle: 'bold', textColor: [80, 80, 80] } 
    }]],
    theme: 'plain',
    styles: { fontSize: 8, cellPadding: 1, valign: 'middle' },
    margin: { left: 14, right: 14 },
});
yPos = doc.lastAutoTable.finalY + 6;
} else {
// if we skipped, optionally leave a small gap so layout doesn't crowd
// comment out next line if you want zero gap
yPos += 4;
}

        

//     // FIX: Yeh check add karein. Agar text undefined, null ya khali hai to function yahin ruk jayega.
//     if (!text) {
//         return;
//     }

//     const cleanText = text.replace(/<[^>]+>/g, '').trim();
//     if (!cleanText) return;
    
//     const splitText = doc.splitTextToSize(cleanText, 270);
//     const neededHeight = (splitText.length * 4) + 12;

//     if (yPos + neededHeight > pageHeight - pageBuffer) { 
//         yPos = await addNewPage(); 
//     }
    
//     doc.setDrawColor(0, 0, 0).setLineWidth(0.2).rect(14, yPos, 182, neededHeight);
//     doc.setFontSize(9).setFont('helvetica', 'bold').text(title, 16, yPos + 5);
//     doc.setFontSize(8).setFont('helvetica', 'normal').text(splitText, 16, yPos + 11);
//     yPos += neededHeight + 6;
// };



// Replace your old drawBorderedSection with this improved version
// Replaces your previous drawBorderedSection
// Replace your old drawBorderedSection with this one


const drawBorderedSection = async (title, htmlContent) => {
    if (!htmlContent) return;
  
    // Normalize input and quick empty check
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = String(htmlContent || '').trim();
  
    // If nothing useful (no visible text and no table), skip
    const plainText = tempDiv.innerText.replace(/\u00A0/g, ' ').trim();
    const hasTable = !!tempDiv.querySelector('table');
    if (!plainText && !hasTable) return;
  
    // Save start page and start Y for the box calculation
    const startPage = doc.internal.getNumberOfPages();
    const boxTop = yPos; // top of the box BEFORE we write title/content
  
    // Reserve space for title if present
    if (title) {
      if (yPos + 12 > pageHeight - pageBuffer) {
        yPos = await addNewPage();
      }
      doc.setFontSize(9).setFont('helvetica', 'bold').text(String(title), 16, yPos + 5);
      yPos += 11; // space after title
    } else {
      if (yPos + 6 > pageHeight - pageBuffer) {
        yPos = await addNewPage();
      }
      yPos += 2;
    }
  
    // Helper: fallback conversion: tableElement => head/body arrays
    const tableToArrays = (tableEl) => {
      const rows = [];
      const headerRow = tableEl.querySelector('tr th') ? [] : null;
      tableEl.querySelectorAll('tr').forEach((tr, rIdx) => {
        const cells = [];
        tr.querySelectorAll('th, td').forEach(td => {
          // innerText preserves displayed text; replace non-breaking spaces
          const txt = (td.innerText || '').replace(/\u00A0/g, ' ').trim();
          cells.push(txt);
        });
        // treat first row as head if it contains <th>
        if (rIdx === 0 && tr.querySelectorAll('th').length > 0) {
          // header as array-of-arrays expected by autoTable
          headerRow.push(...cells);
        } else {
          rows.push(cells);
        }
      });
      return { head: headerRow && headerRow.length ? [headerRow] : null, body: rows };
    };
  
    // Render child nodes in document order
    const nodes = Array.from(tempDiv.childNodes || []);
    for (const node of nodes) {
      // page break guard
      if (yPos > pageHeight - pageBuffer) {
        yPos = await addNewPage();
      }
  
      // If the node is a TABLE element, try to render it via autoTable(html)
      if (node.nodeType === 1 && node.tagName.toUpperCase() === 'TABLE') {
        try {
          if (yPos + 12 > pageHeight - pageBuffer) yPos = await addNewPage();
      
          // ✅ Force table text and lines black
          autoTable(doc, {
            startY: yPos,
            html: node,
            theme: 'grid',
            styles: {
              fontSize: 9,
              cellPadding: 2,
              valign: 'middle',
              textColor: [0, 0, 0], // black text
              lineColor: [0, 0, 0], // black border lines
              lineWidth: 0.2
            },
            headStyles: {
              textColor: [0, 0, 0],
              fillColor: [255, 255, 255],
              fontStyle: 'bold'
            },
            margin: { left: 14, right: 14 }
          });
      
          yPos = doc.lastAutoTable ? doc.lastAutoTable.finalY + 6 : yPos + 17;
               }       catch (err) {
          // Fallback: version might not support `html` option — convert manually
          console.warn('autoTable html render failed, falling back to manual table conversion', err);
          const { head, body } = tableToArrays(node);
          if (body && body.length > 0) {
            if (yPos + (body.length * 8) > pageHeight - pageBuffer) {
              yPos = await addNewPage();
            }
            autoTable(doc, {
              startY: yPos,
              head: head || undefined,
              body: body,
              theme: "grid",
              styles: { fontSize: 9, cellPadding: 2, valign: "middle" },
              margin: { left: 14, right: 14 }
            });
            yPos = doc.lastAutoTable.finalY + 6;
          }
        }
      } else {
        // Non-table nodes — render with drawHtmlContent (we already have this)
        const htmlChunk = (node.outerHTML !== undefined) ? node.outerHTML : node.nodeValue;
        if (!htmlChunk || String(htmlChunk).trim() === '') continue;
  
        yPos = await drawHtmlContent(doc, htmlChunk, 16, yPos, {
          maxWidth: 178,
          addNewPage,
          pageHeight,
          pageBuffer
        });
        yPos += 4;
      }
    }
  
    // Draw border if content stayed on same page — compute height robustly
    const endPage = doc.internal.getNumberOfPages();
    if (startPage === endPage) {
      // compute used height; add small padding
      const boxHeight = Math.max(12, yPos - boxTop + 2);
      try {
        const boxLeft = 14;
        const boxWidth = (doc.internal.pageSize.getWidth ? doc.internal.pageSize.getWidth() : doc.internal.pageSize.width) - (boxLeft * 2);
        doc.setDrawColor(0, 0, 0).setLineWidth(0.2).rect(boxLeft, boxTop, boxWidth, boxHeight);
      } catch (e) {
        console.warn("drawBorderedSection: drawing border failed:", e);
      }
    } else {
      // If it spilled to next page, drawing one big rectangle would be wrong.
      // Optionally draw a top border on first page and a bottom border on last page — left as enhancement.
    }
  
    // small gap after whole section
    yPos += 6;
  };
  
  
  

        await drawBorderedSection('Interpretation', test.interpretation);
        await drawBorderedSection('Impression', test.impression);
        await drawBorderedSection('Notes:', test.notes);
    }

    // --- End of Report and Finalization (Ye waise hi rahenge) ---
    if (yPos + 20 > pageHeight - pageBuffer) { yPos = await addNewPage(); }
    doc.setFontSize(12).setFont('helvetica', 'bold');
    doc.text('*** End of Report ***', pageWidth / 2, yPos + 10, { align: 'center' });

    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        if (hasRadiology) {
    await addSignatures(doc, formData.selItem['60']);
} else {
    await addSignatures(doc, formData.selItem['32']);
}

        doc.setFontSize(8).setTextColor(0, 0, 0);
        const pageText = `Page ${i} of ${totalPages}`;
        doc.text(pageText, pageWidth - 14, pageHeight - 15, { align: 'right' });
    }

    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
const newWindow = window.open(pdfUrl, '_blank');
if (newWindow) {
  newWindow.onload = () => { /* newWindow.print(); */ URL.revokeObjectURL(pdfUrl); };
} else {
  // fallback: download
  const a = document.createElement('a');
  a.href = pdfUrl;
  a.download = `report_${selectedUser.lab_reg_id || 'report'}.pdf`;
  a.click();
  URL.revokeObjectURL(pdfUrl);
}

    newWindow.onload = function () {
        // newWindow.print(); // Comment this during development to prevent print dialog
    };
};


const handlePrintSingleTest = (test) => {
        generatePdfForTests([test]);
    };


    const handlePrintAllTests = () => {
        generatePdfForTests(formData.l11);
    };

const isOutOfRange = (param) => {
  const value = parseFloat(param.result);
  const from = parseFloat(param.test_param_from_range);
  const to = parseFloat(param.test_param_to_range);

  if (isNaN(value) || isNaN(from) || isNaN(to)) return false;

  const min = Math.min(from, to);
  const max = Math.max(from, to);

  return value < min || value > max;
};

const isAnyResultFilled = (params) => {
  if (!params) return false;
  return params.some(param => param.result && param.result.toString().trim() !== '');
};

const handleCKEditorChange = (data, paramIndex, testIndex) => {
  setFormData(prev => {
    // Deep copy kar rahe hain taaki state immutability maintain ho
    const updatedTests = prev.l11.map((test, tIndex) => {
      if (tIndex !== testIndex) return test;

      // Current test ka params update kar rahe hain
      const updatedParams = test.params.map((param, pIndex) => {
        if (pIndex !== paramIndex) return param;
        return { ...param, result: data }; // editor ka latest content
      });

      return { ...test, params: updatedParams };
    });

    return { ...prev, l11: updatedTests };
  });
};



// console.log("Selected User:", selectedUser);

   useEffect(() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData2();
        }
    }, []);

//     useEffect(() => {
//   setFilteredPatients(uniquePatients);
// }, []);

    return (
        <>
            <style>{styles}</style>
          
            <div className="page-content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header border-0">
                                <h2 className="card-title mb-0" style={{color:"#405189"}}>Report Entry</h2>
                        </div>
                        <div className="card-body report-entry-container">
                            <form onSubmit={handleSubmit}>
                                {/* --- Filter and Patient Selection Section --- */}
                                <div className="row align-items-end gy-3 mb-4">
                                    <div className="col-md-3">
                                        <label className="form-label">From</label>
                                        <input className="form-control" type="date" name="from" onChange={handleChange} value={formData.from} />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label">To</label>
                                        <input className="form-control" type="date" name="to" onChange={handleChange} value={formData.to} />
                                    </div>

                                     <div className="col-md-2">
                                         <button type="button" onClick={handleSearch} className="btn btn-success w-100">Search</button>
                                     </div>
                                    <div className="col-md-4">
                                        <label className="form-label">Patient</label>
       <div className="position-relative">
       <input
  type="text"
  ref={inputRef}
  className="form-control"
  placeholder="Search Patient by Name or UHID..."
  value={searchKey}
  onChange={handleSearchInputChange}
  onFocus={() => {
    setShowSearchDropdown(true);
  
    // If we are still loading data from server, show current filtered state (may be empty) and avoid toasts.
    if (patientsLoading) {
      // just keep filteredPatients as is — dropdown will show a "Loading..." item
      return;
    }
  
    if (!searchKey) {
      // show preloaded today's list when available else show uniquePatients
      setFilteredPatients((todaysPatients && todaysPatients.length) ? todaysPatients : uniquePatients);
      // Do not toast here — use dropdown messaging instead
    }
  }}
  
  
  onBlur={handleBlur}
  onKeyDown={handleSearchKeyDown}   // <-- ADD THIS
/>

{showSearchDropdown && (
  <ul
    className="list-group position-absolute w-100 zindex-dropdown"
    style={{ maxHeight: "200px", overflowY: "auto" }}
    ref={dropdownRef}
  >
    {patientsLoading ? (
      <li className="list-group-item" style={{ cursor: "default" }}>
        Loading patients...
      </li>
    ) : (filteredPatients && filteredPatients.length > 0) ? (
      filteredPatients.map((item, index) => (
        <li
          key={index}
          className="list-group-item list-group-item-action"
          onMouseDown={() => handlePatientSelect(item)}
          style={{ cursor: "pointer" }}
        >
          {item.lab_reg_name} ({item.lab_reg_uhid})
        </li>
      ))
    ) : (
      <li className="list-group-item" style={{ cursor: "default" }}>
        No patients for the selected date. Choose a date range and click Search to fetch records.
      </li>
    )}
  </ul>
)}

</div>




                                    </div>
                                    
                                </div>
                                
                                {/* --- NEW: Patient Details Section --- */}
                                {selectedUser && (
                                    <div className="patient-details-card mb-4">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <td><strong>Name</strong></td>
                                                    <td>: {`${selectedUser.lab_reg_name_title ? selectedUser.lab_reg_name_title + ' ' : ''}${selectedUser.lab_reg_name}`}</td>

                                                    <td><strong>Reg. No.</strong></td>
                                                    <td>: {selectedUser.lab_reg_id}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Age/Gender</strong></td>
                                                    <td>: {selectedUser.lab_reg_age_year}Y / {selectedUser.lab_reg_gender}</td>
                                                    <td><strong>Reg. Date</strong></td>
                                                    <td>: {new Date(selectedUser.lab_reg_date).toLocaleDateString('en-GB')}
</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Ref By</strong></td>
                                                    <td>: {selectedUser.lab_reg_referral}</td>
                                                     <td><strong>UHID</strong></td>
                                                    <td>: {selectedUser.lab_reg_uhid}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                )}


{selectedUser && (
  <MachineResultImport
    selectedUser={selectedUser}
    formData={formData}
    setFormData={setFormData}
  />
)}





                             {/* --- NEW: Accordion-style Investigation & Report Table Section --- */}
                                {selectedUser && formData.l11.length > 0 && (
                                      selectedUser?.lab_reg_status === "Pending" ? (
        <div className="alert alert-warning mt-4">
            Sample not collected
        </div>
    ) : (
                                    <div className="investigation-section-accordion mt-4">
                                        {formData.l11.map((item, index) => {
                                            const isActive = activeIndex === index;
                                            const areResultsFilled = isAllResultsFilled(item.params);
                                            return (
                                                <div className="accordion-item" key={index}>
                                                    {/* Accordion Header */}
                                                   {/* Accordion Header */}
{/* Accordion Header */}
<div
  className="accordion-header"
  role="button"
  aria-expanded={isActive ? "true" : "false"}
  onClick={() => setActiveIndex(isActive ? null : index)}
  style={{ cursor: "pointer" }}
>
  {/* Checkbox for selecting this test */}
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <input
      type="checkbox"
      checked={selectedTests.has(item.lab_item_test_id)}
      onChange={(e) => { e.stopPropagation(); handleToggleTestSelect(item); }}
      aria-label={`Select ${item.lab_item_test_name} for printing`}
      onClick={(e) => e.stopPropagation()} // extra safety for some browsers
    />
  </div>

  {/* Explicit +/- button (keep separate so user can still click it) */}
  <button
    type="button"
    className={`btn accordion-toggle-btn ${isActive ? 'active' : ''}`}
    onClick={(e) => { e.stopPropagation(); setActiveIndex(isActive ? null : index); }}
    aria-label={isActive ? "Collapse" : "Expand"}
  >
    {isActive ? '−' : '+'}
  </button>

  {/* Title area — clicking this (or anywhere on header) will toggle */}
  <div className="accordion-title" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <span>{item.lab_item_test_name}</span>
    {item.lab_item_test_code && <small style={{ color: '#6c757d' }}>{item.lab_item_test_code}</small>}
  </div>

  {/* Print button — prevent propagation so it doesn't toggle accordion */}
  <button 
    type="button" 
    className="btn btn-primary btn-sm"   
    //disabled={!isAnyResultFilled(item.params) || !isReportSaved}
    onClick={(e) => { 
      e.stopPropagation();
      setPendingPrintAction(() => () => handlePrintSingleTest(item, printType));
      setShowPrintPopup(true);
    }}
  >
    Print
  </button>
</div>



                                                    {/* Accordion Body */}
                                                    {isActive && (
                                                        <div className="accordion-body">
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered report-table">
                                                                    <thead className="table-header-blue">
                                                                        <tr>
                                                                            <th style={{width: "5%"}}>S.No.</th>
                                                                            <th>Investigation Name</th>
                                                                            <th style={{width: "20%"}}>Result</th>
                                                                            <th style={{width: "15%"}}>Units</th>
                                                                            <th>Reference Ranges</th>
                                                                            <th style={{width: "20%"}}>Method</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {item.params && item.params.map((param, paramIndex) => {
  // Detect if param name is wrapped by asterisks like *demo*
  const rawName = String(param.test_param_name || "");
  const isStarred = /^\*.+\*$/.test(rawName.trim());
  const displayName = isStarred ? rawName.trim().replace(/^\*(.+)\*$/, '$1') : rawName;

  return (
    <tr key={`row-${paramIndex}`}>
      <td>{paramIndex + 1}</td>
      <td style={{ fontWeight: isStarred ? 700 : 'normal' }}>{displayName}</td>

      {param.test_param_type === "Editor" ? (
        <td colSpan={4}>
          <CKEditor
            editor={ClassicEditor}
            data={param.result || get_param_val(param) || ''}
            onChange={(event, editor) => {
              const data = editor.getData();
              handleCKEditorChange(data, paramIndex, index);
            }}
          />
        </td>
      ) : (
        <>
          <td>
  {isStarred ? (
    <div style={{ padding: '6px 8px' /* match input padding a bit */ }}>
      {param.result && param.result.toString().trim() !== '' ? param.result : '—'}
    </div>
  ) : (
    // <input
    //   className={`form-control ${isOutOfRange(param) ? 'border-red' : ''}`}
    //   type={get_param_val1(param) === 1 ? "number" : "text"}
    //   value={param.result || ''}
    //   onChange={(e) => handleChange1(e, paramIndex, index)}
    // />



    <input
  className={`form-control ${isOutOfRange(param) ? 'border-red' : ''}`}
  type={get_param_val1(param) === 1 ? "number" : "text"}
  value={param.result || ''}
  onChange={(e) => handleChange1(e, paramIndex, index)}
  onWheel={(e) => {
    // prevent wheel from changing the value; keep cursor in place
    // e.preventDefault() sometimes blocked; blurring is reliable.
    // Here we prevent default (works in React) and also blur to be safe.
    e.currentTarget.blur();
    e.preventDefault();
  }}
  onKeyDown={(e) => {
    // optional: prevent non-numeric characters like 'e' which are allowed in number inputs
    if (get_param_val1(param) === 1) {
      // allow: digits, backspace, delete, arrow keys, tab, dot and minus if you want
      const allowed = [
        'Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End'
      ];
      if (allowed.includes(e.key)) return;
      // allow dot and minus only if you want (here I allow dot)
      if (e.key === '.' || e.key === '-') return;
      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
      }
    }
  }}
/>

  )}
</td>

          <td>{param.test_range_type}</td>
          <td>{get_param_val(param)}</td>
          <td>{param.test_param_method || ""}</td>
        </>
      )}
    </tr>
  );
})}




                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            
                                                          {/* --- Additional Notes card (collapsed by default) --- */}
<div className="row mt-4">
  <div className="col-12">
    <div className="card">
      <div
        className="card-header d-flex justify-content-between align-items-center"
        style={{ cursor: "pointer", userSelect: "none" }}
        onClick={() => toggleNotes(index)}
      >
        <div style={{ fontWeight: 600 }}>Additional Notes</div>
        <div>
          <button
            type="button"
            className="btn btn-sm btn-link"
            onClick={(e) => { e.stopPropagation(); toggleNotes(index); }}
            aria-expanded={!!openNotes[index]}
          >
            {openNotes[index] ? "−" : "+"}
          </button>
        </div>
      </div>

      {/* card body - toggled */}
      <div
        className={`card-body ${openNotes[index] ? "show" : "collapse"}`}
        style={{ display: openNotes[index] ? "block" : "none" }}
      >
        <div className="row">
          <div className="col-md-6">
            <label className="form-label">Impression</label>
            <textarea
              className="form-control"
              value={formData.l11[index].impression || ""}
              onChange={(e) => {
                const updated = [...formData.l11];
                updated[index] = { ...updated[index], impression: e.target.value };
                setFormData(prev => ({ ...prev, l11: updated }));
              }}
              placeholder="Enter Impression"
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Notes</label>
            <textarea
              className="form-control"
              value={formData.l11[index].notes || ""}
              onChange={(e) => {
                const updated = [...formData.l11];
                updated[index] = { ...updated[index], notes: e.target.value };
                setFormData(prev => ({ ...prev, l11: updated }));
              }}
              placeholder="Enter Notes"
            />
          </div>

          <div className="col-12 mt-3">
            <label className="form-label">Interpretation</label>
            <CKEditor
              editor={ClassicEditor}
              data={formData.l11[index].interpretation || ""}
              onChange={(event, editor) => {
                const data = editor.getData();
                const updated = [...formData.l11];
                updated[index] = { ...updated[index], interpretation: data };
                setFormData(prev => ({ ...prev, l11: updated }));
              }}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

                                                            <div className="text-end mt-2">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success"
                                                                    onClick={() => handleSaveNext(index)}
                                                                   disabled={!isAnyResultFilled(item.params)}
                                                                >
                                                                    {index < formData.l11.length - 1 ? 'Save & Next' : 'Finish'}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
    )
                                )}

                                {/* --- Footer Buttons --- */}
                                <div className="text-end mt-4 d-flex justify-content-end align-items-center" style={{ gap: 8 }}>
  {/* Select All */}
  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginRight: 8 }}>
    <input
      id="select-all-tests"
      type="checkbox"
      checked={selectAllTests}
      onChange={handleToggleSelectAll}
    />
    <label htmlFor="select-all-tests" style={{ margin: 0 }}>Select All</label>
  </div>

  {/* Print Selected */}
  <button
    type="button"
    className="btn btn-warning me-2"
    disabled={selectedTests.size === 0 || !isReportSaved}
    onClick={() => {
      // if you want the print-type modal first, open it like others:
      setPendingPrintAction(() => handlePrintSelectedTests);
      setShowPrintPopup(true);
    }}
  >
    Print Selected
  </button>

  {/* Print All (keep existing) */}
  {/* <button 
    type="button" 
    className="btn btn-info me-2"
    disabled={!isReportSaved}
    onClick={() => { 
        setPendingPrintAction(() => () => handlePrintAllTests(printType));
        setShowPrintPopup(true);
    }}
  >
    Print All Tests
  </button> */}

  {/* Save */}
  {selectedUser?.lab_reg_status !== "Pending" && (
    <button type="submit" className="btn btn-primary">
      Save Report
    </button>
  )}
</div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {showPrintPopup && (
    <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Select Print Type</h5>
                    <button type="button" className="btn-close" onClick={() => setShowPrintPopup(false)}></button>
                </div>
                <div className="modal-body">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            value="without"
                            checked={printType === "without"}
                            onChange={() => setPrintType("without")}
                        />
                        <label className="form-check-label">Without Header</label>
                    </div>
                    <div className="form-check mt-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            value="with"
                            checked={printType === "with"}
                            onChange={() => setPrintType("with")}
                        />
                        <label className="form-check-label">With Header</label>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-danger" onClick={() => setShowPrintPopup(false)}>Close</button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                            setShowPrintPopup(false);
                            if (pendingPrintAction) pendingPrintAction();
                        }}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    </div>
)}

        </>
    );
};

export default ReportEntry;